import { IVehiclesState } from '../states';

export const initialVehiclesState: IVehiclesState = {
  value: [],
  isFetchingVehicles: false,
};
